import * as Types from '../../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteIvrMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  relatedData?: Types.InputMaybe<Types.ReferenceRetargetsIvr>;
}>;


export type DeleteIvrMutation = { __typename?: 'Mutation', deleteIvr?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', type: string, location: Array<string>, context?: string | null }> | null } | null };

export type IvrRetargetsQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type IvrRetargetsQuery = { __typename?: 'Query', users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, gateways?: { __typename?: 'GatewayList', items: Array<{ __typename?: 'Gateway', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, ivrs?: { __typename?: 'IvrList', items: Array<{ __typename?: 'Ivr', id: number, name: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, faxes?: { __typename?: 'FaxList', items: Array<{ __typename?: 'Fax', id: number, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, groups?: { __typename?: 'GroupList', items: Array<{ __typename?: 'Group', id: number, name: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null };


export const DeleteIvrDocument = gql`
    mutation DeleteIvr($id: Int!, $relatedData: ReferenceRetargetsIvr) {
  deleteIvr(id: $id, relatedData: $relatedData) {
    errors {
      type
      location
      context
    }
  }
}
    `;
export type DeleteIvrMutationFn = Apollo.MutationFunction<DeleteIvrMutation, DeleteIvrMutationVariables>;

/**
 * __useDeleteIvrMutation__
 *
 * To run a mutation, you first call `useDeleteIvrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIvrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIvrMutation, { data, loading, error }] = useDeleteIvrMutation({
 *   variables: {
 *      id: // value for 'id'
 *      relatedData: // value for 'relatedData'
 *   },
 * });
 */
export function useDeleteIvrMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIvrMutation, DeleteIvrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIvrMutation, DeleteIvrMutationVariables>(DeleteIvrDocument, options);
      }
export type DeleteIvrMutationHookResult = ReturnType<typeof useDeleteIvrMutation>;
export type DeleteIvrMutationResult = Apollo.MutationResult<DeleteIvrMutation>;
export type DeleteIvrMutationOptions = Apollo.BaseMutationOptions<DeleteIvrMutation, DeleteIvrMutationVariables>;
export const IvrRetargetsDocument = gql`
    query IvrRetargets($domainId: Int!) {
  users(domainId: $domainId) {
    items {
      id
      displayName
      number {
        id
        shortNumber
      }
    }
  }
  gateways(domainId: $domainId) {
    items {
      id
      displayName
      number {
        id
        shortNumber
      }
    }
  }
  ivrs(domainId: $domainId) {
    items {
      id
      name
      number {
        id
        shortNumber
      }
    }
  }
  faxes(domainId: $domainId) {
    items {
      id
      number {
        id
        shortNumber
      }
    }
  }
  groups(domainId: $domainId) {
    items {
      id
      name
      number {
        id
        shortNumber
      }
    }
  }
}
    `;

/**
 * __useIvrRetargetsQuery__
 *
 * To run a query within a React component, call `useIvrRetargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIvrRetargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIvrRetargetsQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useIvrRetargetsQuery(baseOptions: Apollo.QueryHookOptions<IvrRetargetsQuery, IvrRetargetsQueryVariables> & ({ variables: IvrRetargetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IvrRetargetsQuery, IvrRetargetsQueryVariables>(IvrRetargetsDocument, options);
      }
export function useIvrRetargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IvrRetargetsQuery, IvrRetargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IvrRetargetsQuery, IvrRetargetsQueryVariables>(IvrRetargetsDocument, options);
        }
export function useIvrRetargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IvrRetargetsQuery, IvrRetargetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IvrRetargetsQuery, IvrRetargetsQueryVariables>(IvrRetargetsDocument, options);
        }
export type IvrRetargetsQueryHookResult = ReturnType<typeof useIvrRetargetsQuery>;
export type IvrRetargetsLazyQueryHookResult = ReturnType<typeof useIvrRetargetsLazyQuery>;
export type IvrRetargetsSuspenseQueryHookResult = ReturnType<typeof useIvrRetargetsSuspenseQuery>;
export type IvrRetargetsQueryResult = Apollo.QueryResult<IvrRetargetsQuery, IvrRetargetsQueryVariables>;